import {styled} from '@mui/material'

export const ScrollContainer = styled('div')(({theme}) => ({
  display: 'flex',
  gap: '20px',
  overflowX: 'auto',
  overflowY: 'hidden',
  padding: '20px 0',
  height: '470px',
  justifyContent: 'flex-start',
  width: '100%'
}))

export const ImageCardContainer = styled('div')(({theme}) => ({
  flexShrink: 0,
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  height: '430px',
  maxHeight: '430px'
}))

export const ImageContainer = styled('div')(({theme}) => ({
  position: 'relative',
  width: '100%',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px',
  minHeight: 0
}))

export const InfoFooter = styled('div')(({theme}) => ({
  padding: '12px 16px',
  flexShrink: 0,
  minHeight: '60px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}))
